// node-modules
import axios, { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react';
import { Common } from '../../common/src';
import { config } from '../config/config';
const Upload = () => {
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [file, setFile] = useState<File>();
    const [jobsitesInfo, setJobsitesInfo] = useState<Common.LandlogJobsitesInfo>();
    const [projectId, setProjectId] = useState<string>('');
    const [projectName, setProjectName] = useState<string>('');
    const [directoryName, setDirectoryName] = useState<string>('');
    const [jobsiteId, setJobsiteId] = useState<string>('');
    const [timeStamp, setTimeStamp] = useState<string>('');
    const [useArmarker, setUseArmarker] = useState<string>('');
    const [uploadFlg, setUploadFlg] = useState<string>('');

    const getFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return
        const file: File = e.target.files[0];
        setFile(file);
    };

    const getJobsitesInfo = async () => {
        try {
            await axios.get(`${config.serverHost}/api/v1/sites`, { withCredentials: true })
                .then((res: AxiosResponse<Common.LandlogJobsitesInfo>) => {
                    const jobsitesInfo = res.data;
                    setJobsitesInfo(jobsitesInfo);
                    if (jobsitesInfo.sites[0]) {
                        setJobsiteId(jobsitesInfo.sites[0].id);
                    }
                });
        } catch (err) {
            console.error(`err: ${err}`);
        }
    }

    const projectIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setProjectId(e.target.value);
    };

    const projectNameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setProjectName(e.target.value);
    };

    const directoryNameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDirectoryName(e.target.value);
    };

    const timeStampChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTimeStamp(e.target.value);
    };

    const useArmarkerHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUseArmarker(e.target.value);
    };

    const uploadFlgHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUploadFlg(e.target.value);
    };

    useEffect(() => {
        getJobsitesInfo();
    }, []);

    // curl localhost:3001/api/v1/project/upload -b userId='92941989-282a-48f6-bd8d-713c188fd0d6' -F 'uploadFile=@./test_inputs.zip' -F 'jobsiteId=4d265b93-00e7-4836-acea-9ad7f3beb461' -F 'projectName=test_project' -F 'directory="/test"'
    const uploadFile = async () => {
        try {
            if (file) {
                const data = new FormData();
                data.append('uploadFile', file);
                data.append('projectName', projectName);
                data.append('jobsiteId', jobsiteId);
                data.append('directory', directoryName);
                let d = new Date();
                if (timeStamp !== "") {
                    d = new Date(timeStamp);
                    data.append('timeStamp', d.toISOString());
                }
                data.append('useArmarker', useArmarker);
                const timezone: number = new Date().getTimezoneOffset() * (-1);
                data.append('timezone', `${timezone}`);

                if (uploadFlg === 'true' || uploadFlg === '') {
                    await axios.post(`${config.serverHost}/api/v1/project/upload`, data, { withCredentials: true })
                        .then((res: any) => {
                            setErrorMessage("");
                            alert(`upload finish status: ${res.status}`);
                        }).catch((err: any) => {
                            setErrorMessage(`file upload error ${err}`);
                        });
                } else {
                    await axios.put(`${config.serverHost}/api/v1/project/upload/${projectId}`, data, { withCredentials: true })
                        .then((res: any) => {
                            setErrorMessage("");
                            alert(`upload finish status: ${res.status}`);
                        }).catch((err: any) => {
                            setErrorMessage(`file upload error ${err}`);
                        });
                }

            } else {
                setErrorMessage('file not exists');
            }
        } catch (err) {
            setErrorMessage(`file upload error: ${err}`);
        }
    };

    return (<div>
        <h2 style={{ color: "white" }}>{errorMessage}</h2><br />
        <h3 style={{ color: "white" }}>PROJECT UPLOAD</h3><br />
        <form>
            <input id="uploadFlg" type="radio" name="uploadFlg" value="true" onChange={uploadFlgHandler} />
            <label style={{ color: "white" }}>新規　</label>
            <input id="uploadFlg" type="radio" name="uploadFlg" value="false" onChange={uploadFlgHandler} />
            <label style={{ color: "white" }}>更新</label>
            <br />
            <label style={{ color: "white" }}>プロジェクトID</label>
            <input id="projectName" type="text" name="projectId" value={projectId} onChange={projectIdChangeHandler} /><label style={{ color: "white" }}>(更新の場合入力)</label><br />
            <label style={{ color: "white" }}>プロジェクト名</label>
            <input id="projectName" type="text" name="projectName" value={projectName} onChange={projectNameChangeHandler} /><br />

            <label style={{ color: "white" }}>ディレクトリ名</label>
            <input id="directoryName" type="text" name="directoryName" value={directoryName} onChange={directoryNameChangeHandler} /><br />

            <label style={{ color: "white" }}>現場選択</label>
            <select name="jobsite" value={jobsiteId} onChange={e => setJobsiteId(e.target.value)}>
                {
                    jobsitesInfo?.sites.map(site => {
                        return (<option value={site.id}>{site.name}</option>);
                    })
                }
            </select><br />

            <label style={{ color: "white" }} htmlFor='zip'>zipファイル</label>
            <input id="file" type="file" accept=".zip" style={{ color: "white" }} onChange={getFile} /><br />

            <label style={{ color: "white" }}>登録日時</label>
            <input id="timeStamp" type="text" name="timeStamp" value={timeStamp} onChange={timeStampChangeHandler} placeholder="yyyy/mm/dd hh/mi/ss" />
            <label style={{ color: "white" }}>※未入力の場合、送信しない</label>
            <br />
            <label style={{ color: "white" }}>ARマーカー利用　</label>
            <input id="useArmarker" type="radio" name="useArmarker" value="true" onChange={useArmarkerHandler} />
            <label style={{ color: "white" }}>はい</label>
            <input id="useArmarker" type="radio" name="useArmarker" value="false" onChange={useArmarkerHandler} />
            <label style={{ color: "white" }}>いいえ</label>
            <br />
            <input type="button" value="アップロード" onClick={uploadFile} /><br />

        </form>
    </div>);
}

export default Upload;